import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Graph from './evolutionGraph';

const Indicators = props => (
  <div className="container-detail-indicators">
    <div className="box-detail-indicators">
      <div className="item-detail-indicators">
        <div className="item-detail-indicators--one">tets</div>
        <div className="item-detail-indicators--two">
          <CircularProgress
            className={'circular-red'}
            variant="static"
            value={40}
            thickness={3}
            size={60}
          />
          <CircularProgress
            className={'circular-2'}
            variant="static"
            value={100}
            thickness={3}
            size={60}
          />
          <h5 className="red">40%</h5>
          <span className="red">
            <i className="fas fa-arrow-down" />
          </span>
          <h6 className="red">10%</h6>
        </div>
        <div className="item-detail-indicators--three">
          <ul>
            <li> test: 167</li>
            <li>test: 70</li>
            <li>test: 35(50%)</li>
          </ul>
          <Graph data={props.data} id="test1" />
        </div>
      </div>
      <div className="item-detail-indicators--four">
        <a data-close="ok" onClick={props.handleModal}>
          test
        </a>
      </div>
    </div>
    <div className="box-detail-indicators">
      <div className="item-detail-indicators">
        <div className="item-detail-indicators--one">tets</div>
        <div className="item-detail-indicators--two">
          <CircularProgress
            className={'circular-red'}
            variant="static"
            value={40}
            thickness={3}
            size={60}
          />
          <CircularProgress
            className={'circular-2'}
            variant="static"
            value={100}
            thickness={3}
            size={60}
          />
          <h5 className="red">40%</h5>
          <span className="red">
            <i className="fas fa-arrow-down" />
          </span>
          <h6 className="red">10%</h6>
        </div>
        <div className="item-detail-indicators--three">
          <ul>
            <li>test: 167</li>
            <li>test: 70</li>
            <li>test: 35(50%)</li>
          </ul>
          <Graph data={props.data} id="test2" />
        </div>
      </div>
      <div className="item-detail-indicators--four">
        <a>test</a>
      </div>
    </div>
    <div className="box-detail-indicators">
      <div className="item-detail-indicators">
        <div className="item-detail-indicators--one">tets</div>
        <div className="item-detail-indicators--two">
          <CircularProgress
            className={'circular-yellow'}
            variant="static"
            value={60}
            thickness={3}
            size={60}
          />
          <CircularProgress
            className={'circular-2'}
            variant="static"
            value={100}
            thickness={3}
            size={60}
          />
          <h5 className="yellow">60%</h5>
          <span className="yellow">
            <i className="fas fa-arrow-down" />
          </span>
          <h6 className="yellow">10%</h6>
        </div>
        <div className="item-detail-indicators--three">
          <ul>
            <li>test: 167</li>
            <li>test: 70</li>
            <li>test: 35(50%)</li>
          </ul>
          <Graph data={props.data} id="test3" />
        </div>
      </div>
      <div className="item-detail-indicators--four">
        <a>test</a>
      </div>
    </div>
    <div className="box-detail-indicators">
      <div className="item-detail-indicators">
        <div className="item-detail-indicators--one">tets</div>
        <div className="item-detail-indicators--two">
          <CircularProgress
            className={'circular-green'}
            variant="static"
            value={80}
            thickness={3}
            size={60}
          />
          <CircularProgress
            className={'circular-2'}
            variant="static"
            value={100}
            thickness={3}
            size={60}
          />
          <h5 className="green">80%</h5>
          <span className="green">
            <i className="fas fa-arrow-down" />
          </span>
          <h6 className="green">10%</h6>
        </div>
        <div className="item-detail-indicators--three">
          <ul>
            <li>test: 167</li>
            <li>test: 70</li>
            <li>test: 35(50%)</li>
          </ul>
          <Graph data={props.data} id="test4" />
        </div>
      </div>
      <div className="item-detail-indicators--four">
        <a>test</a>
      </div>
    </div>
  </div>
);

export default Indicators;



// WEBPACK FOOTER //
// ./source/client/components/detail_fulfillment/indicators.jsx